import React from 'react';
import { useTableInstance } from '../TableContext/TableContext.esm.js';
import '../TableContext/TableProvider.esm.js';
import { ConfigureColumns } from './ConfigureColumns.esm.js';

const ConnectedConfigureColumns = (props) => {
    const { columns, disableColumnOrder, defaultColumn, state: { columnOrder }, setColumnOrder, setHiddenColumns, dispatch, originalColumns, } = useTableInstance();
    const { setMyRowSize } = props;
    return (React.createElement(ConfigureColumns, { columns: columns, columnOrder: columnOrder, disableColumnOrder: disableColumnOrder, setColumnOrder: setColumnOrder, setHiddenColumns: setHiddenColumns, setMyRowSize: setMyRowSize, resetResize: () => {
            const columnWidths = {};
            columns.map((column) => {
                var _a, _b;
                const original = originalColumns.find((c) => c.accessor === column.id);
                /* istanbul ignore next */
                const width = (_b = (_a = original === null || original === void 0 ? void 0 : original.width) !== null && _a !== void 0 ? _a : defaultColumn === null || defaultColumn === void 0 ? void 0 : defaultColumn.width) !== null && _b !== void 0 ? _b : 150;
                columnWidths[column.id] = width;
            });
            dispatch({
                type: "resetColumnWidths",
                columnWidths: columnWidths,
            });
        } }));
};

export { ConnectedConfigureColumns };
//# sourceMappingURL=ConnectedConfigureColumns.esm.js.map
